<template lang="pug">
div
  BaseButton(data-testid='sendToCustomerButton' class='w-full' size='LARGE' icon='ARROW' @click='openPaylink') Send Paylink
</template>

<script setup lang="ts">
const { $overlay } = useNuxtApp()

function openPaylink() {
  $overlay.open('paylink')
}
</script>
